import {useMutation, useQuery} from "@tanstack/react-query";
import {userService} from "../services/user.service";

export const useGetAllStudents = (params) => {
  return useQuery({
    queryKey: ["get-all-students", params],
    queryFn: () => userService.getAllStudentsService(params),
    keepPreviousData: true,
  });
};

export const useGetUserById = (id) => {
  return useQuery({
    queryKey: ["get-user-by-id", id],
    queryFn: () => userService.getAUserByIdService(id),
  });
};

export const useGetUserCourseAnalytics = (id) => {
  return useQuery({
    queryKey: ["get-user-course-analytics", id],
    queryFn: () => userService.getUserCourseAnalyticsService(id),
  });
};

export const useUpdateUserPassword = () => {
  return useMutation({
    mutationFn: (payload) => userService.updateUserPassword(payload),
  });
};

